// Aggregates all security functionalities
class SecurityService {
  constructor(SessionService, TimeoutService, $state) {
    'ngInject';

    this.SessionService = SessionService;
    this.TimeoutService = TimeoutService;

    this.$state = $state;
  }

  initialize() {
    this.SessionService.initialize();
    // this.SessionService.session.subscribe((sessionDetails) => {
    //   if (sessionDetails) {
    //     this.TimeoutService.initialize();
    //   }
    // });
  }

  authenticate() {
    if (!this.SessionService.getSession()) {
      // This would cause a transition rejection.
      // That is normal since we will transition to signin state without
      // finishing the current transition.
      this.$state.go('signin');
    }
  }

  // TODO: Add actual checking of session on the backend.
  isSessionActive() {
    // We want a distinct value of just true or false.
    return this.SessionService.getSession() ? true : false;
  }

  logout() {
    return this.SessionService.logout();
  }

  login(payload) {
    return this.SessionService.login(payload);
  }
}

export default SecurityService;



// WEBPACK FOOTER //
// ./client/app/shared/security/security.service.js